import { ReactFlowInstance, Node } from "@xyflow/react";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditParallelNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeEditParallelNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeEditParallelNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
   ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const nodeDescription: string = "This node is a routing node.\n" +
    "This node is used to run multiple nodes in parallel.\n";